import React from 'react';
import PageRow from '../PageRow/PageRow';
import Headline from '../../Typography/Headline/Headline';
import { CreateProps } from '../../../types/utils/CreateProps';
import { SupportedTagName } from '../../Typography/Typography';

type PageHeadlineProps = CreateProps<
  {
    /** Make headline narrow */
    narrow?: boolean;
    /** HTML tag name fo Headline */
    tagName?: SupportedTagName;
  },
  typeof Headline
>;

const PageHeadline: React.FunctionComponent<PageHeadlineProps> = ({
  children,
  narrow,
  tagName = 'h1',
  ...props
}) => (
  <PageRow
    narrow={narrow}
    margin={false}
    responsiveFullWidth={narrow}
    hasPanel={false}
  >
    <Headline tagName={tagName} size="lg" {...props}>
      {children}
    </Headline>
  </PageRow>
);

export default PageHeadline;
